import type { ComponentType, ReactElement } from 'react';
import { AspectLines } from './AspectLines';
import { AyanamsaDrift } from './AyanamsaDrift';
import { BhavaMap } from './BhavaMap';
import { DashaBar } from './DashaBar';
import { EastLayout } from './EastLayout';
import { GrahaParivar } from './GrahaParivar';
import { NakshatraBand } from './NakshatraBand';
import { NorthLayout } from './NorthLayout';
import { RashiWheel } from './RashiWheel';
import { SouthLayout } from './SouthLayout';

/**
 * The Learn diagram registry: every schematic figure a lesson can carry, by
 * id. Adding a diagram means adding a file next to this one and one line to
 * REGISTRY — figures.test.ts then insists some lesson actually uses it, so a
 * registered-but-never-shown diagram fails the suite instead of shipping as
 * dead weight.
 */

const REGISTRY = {
  'rashi-wheel': RashiWheel,
  'north-layout': NorthLayout,
  'south-layout': SouthLayout,
  'east-layout': EastLayout,
  'graha-parivar': GrahaParivar,
  'nakshatra-band': NakshatraBand,
  'bhava-map': BhavaMap,
  'dasha-bar': DashaBar,
  'ayanamsa-drift': AyanamsaDrift,
  'aspect-lines': AspectLines,
} satisfies Record<string, ComponentType>;

export type FigureId = keyof typeof REGISTRY;

/** Every registered figure id — the test surface for dead-entry checks. */
export const FIGURE_IDS = Object.keys(REGISTRY) as readonly FigureId[];

/**
 * Render a figure by id. Unknown ids render nothing at all — a lesson with a
 * stale figure id degrades to a plain lesson, never to a crash.
 */
export function LessonFigure({ id }: { id: string }): ReactElement | null {
  const Figure = (REGISTRY as Partial<Record<string, ComponentType>>)[id];
  return Figure ? <Figure /> : null;
}
